import classNames from 'classnames'
import type { FC } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'

import type { AnchorProps } from './types'
import type { PrivateThemeUiProps } from '../../../styles-system/create-component'
import { ButtonPrivate } from '../../button/button'

const Anchor: FC<AnchorProps> = React.forwardRef<
  HTMLAnchorElement,
  AnchorProps & Omit<PrivateThemeUiProps, 'size'>
>(function Anchor(props, ref) {
  const {
    className,
    to,
    role = 'link',
    target = '_self',
    height = 'unset',
    rel,
    fontSize = 'inherit',
    justifyContent,
    emPaddingY,
    emPaddingX,
    ...rest
  } = props
  return (
    <ButtonPrivate
      ref={ref}
      __themeKey="anchors"
      as={to ? Link : 'a'}
      className={classNames(
        {
          'csg-tui-anchor': true,
          'is-disabled': rest.disabled // don't deconstruct this props
        },
        className
      )}
      //@ts-ignore
      to={to}
      role={role}
      target={target}
      rel={target === '_blank' ? 'noopener' : rel}
      fontSize={fontSize}
      height={height}
      emPaddingY={emPaddingY ? emPaddingY : undefined}
      emPaddingX={emPaddingX ? emPaddingX : undefined}
      justifyContent={justifyContent ? justifyContent : 'normal'}
      {...rest}
    />
  )
})

export default Anchor
